import React from 'react'

function FormError({ children }) {
  return <span style={{ color: '#FD3B90', fontSize: '1.1rem' }}>{children}</span>
}

export { FormError }
